<template>
    <div>
      <h2>Condo Attribute Adjustments</h2>
      <div v-for="(attribute, index) in condoAttributes" :key="index">
        <p>{{ attribute.name }}</p>
        <div class="slider-container">
          <input type="range" :min="attribute.min" :max="attribute.max" v-model="attribute.value" @input="calculateTotalValue" class="slider" />
          <div class="slider-value">{{ attribute.min }}</div>
          <div class="slider-value">{{ attribute.max }}</div>
          <div class="slider-average" :style="{ left: getSliderPosition(attribute.value, attribute.min, attribute.max) }">{{ attribute.average }}</div>
        </div>
        <span>{{ attribute.value }}</span>
      </div>
      <p>Total Value Adjustment: {{ totalValue }}</p>
      <button @click="saveCondoAttributes" class="rounded-button">Save Condo Attributes</button>
    </div>
  </template>
  
  <script>
import axios from 'axios';
export default {
  data() {
    return {
      condoAttributes: [
        { name: "Location #1 Value", value: 0 },
        { name: "Location #2 Value", value: 0 },
        { name: "Location #3 Value", value: 0 },
        { name: "Location #4 Value", value: 0 },
        { name: "Location #5 Value", value: 0 },
        { name: "Proximity to Subway Line", value: 0 },
        { name: "Coffee Shop Within 5 Minutes", value: 0 },
        { name: "Hair/Nail Salon Within 5 Minutes", value: 0 },
        { name: "24/7 Concierge", value: 0 },
        { name: "Does not offer a concierge", value: 0 },
        { name: "Buzzer Code Available", value: 0 },
        { name: "AirBnB Policy", value: 0 },
        { name: "Pool", value: 0 },
        { name: "Sauna", value: 0 },
        { name: "Steam Room", value: 0 },
        { name: "Hot tub", value: 0 },
        { name: "Bike Racks", value: 0 },
        { name: "Basketball Court", value: 0 },
        { name: "BBQs", value: 0 },
        { name: "Business Centre", value: 0 },
        { name: "Condo Pets Policy", value: 0 },
        { name: "Beautiful Lobby", value: 0 },
        { name: "Street Noise", value: 0 },
        { name: "Layout Value", value: 0 },
        { name: "Lighting Value", value: 0 },
        { name: "View Value", value: 0 },
        { name: "Balcony Value", value: 0 },
        { name: "Parking Value", value: 0 },
        { name: "Locker Value", value: 0 },
        { name: "Upgrades Necessary Value", value: 0 },
        { name: "Tenant vs Owner Ratio Value", value: 0 },
        { name: "Higher Floor Value", value: 0 },
        { name: "Lower Floor Value", value: 0 },
      ],
      averageValues: {
        "Location #1 Value": 500000,
        "Location #2 Value": 600000,
        "Location #3 Value": 700000,
        "Location #4 Value": 800000,
        "Location #5 Value": 900000,
        "Proximity to Subway Line": 50000,
        "Coffee Shop Within 5 Minutes": 1000,
        "Hair/Nail Salon Within 5 Minutes": 1000,
        "24/7 Concierge": 10000,
        "Does not offer a concierge": -20000,
        "Buzzer Code Available": 0,
        "AirBnB Policy": 0,
        "Pool": 5000,
        "Sauna": 5000,
        "Steam Room": 5000,
        "Hot tub": 5000,
        "Bike Racks": 2000,
        "Basketball Court": 45000,
        "BBQs": 1000,
        "Business Centre": 1000,
        "Condo Pets Policy": 5000,
        "Beautiful Lobby": 25000,
        "Street Noise": -25000,
        "Layout Value": 10000,
        "Lighting Value": 25000,
        "View Value": 25000,
        "Balcony Value": 25000,
        "Parking Value": 60000,
        "Locker Value": 5000,
        "Upgrades Necessary Value": 0,
        "Tenant vs Owner Ratio Value": 0,
        "Higher Floor Value": 0,
        "Lower Floor Value": 0,
      },
      totalValue: 0,
    };
  },
  mounted() {
    this.calculateTotalValue();
  },
  methods: {
    calculateTotalValue() {
      this.totalValue = this.condoAttributes.reduce((total, attribute) => {
        const average = this.averageValues[attribute.name];
        return total + (attribute.value - average);
      }, 0);
    },
    saveCondoAttributes() {
      const condoData = {
        condoAttributes: this.condoAttributes.map((attribute) => ({
          name: attribute.name,
          value: attribute.value,
        })),
      };

      axios
        .post('https://farahk.pythonanywhere.com/modelcondo/view/', condoData, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          console.log('Condo attributes saved successfully:', response.data);
        })
        .catch((error) => {
          console.error('Error saving condo attributes:', error);
        });
    },
    getSliderPosition(value, min, max) {
      const position = ((value - min) / (max - min)) * 100;
      return `${position}%`;
    },
  },
};
</script>


  
<style scoped>
.slider-container {
  position: relative;
  width: 100%;
  margin-top: 10px;
}

.slider {
  width: 100%;
  height: 30px;
}

.slider-value {
  position: absolute;
  font-size: 12px;
  color: #333;
}

.slider-average {
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: black;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 12px;
  top: -10px;
  transform: translateX(-50%);
}

.rounded-button {
  background-color: black;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 25px;
  cursor: pointer;
  margin-top: 20px;
}

.rounded-button:hover {
  background-color: orange;
}
</style>